module.exports = {
    "className": "VoucherPromoCategory",
    "limit": 10,
    "showExport": false,
    "columns": [
      {
        "columnName": "objectId",
            "type": "string"
      },
      {
        "columnName": "name",
        columnLabel: "Promo Category",
        "type": "string"
      },
      {
        "columnName": "createdAt",
            "type": "Date"
      },
      {
        "columnName": "updatedAt",
            "type": "Date"
      }
    ]
}  


// WEBPACK FOOTER //
// ./components/EVoucherPromoCategory/VoucherPromoCategorySchema.js